





















































































































import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import RepairEstimatePartyForm from "@/components/repair-estimate/RepairEstimatePartyForm.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ClearanceApproval, IClearanceApproval } from "@/models/clearance-approval.entity";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { InvoiceParty } from "@/models/invoice-party.entity";
import { IReference } from "@/models/reference.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ClearanceApprovalDataAccessLayer } from "@/store/modules/access-layers/clearance-approval.access-layer";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import ClearanceApprovalSideCard from "../clearance-approval/ClearanceApprovalSideCard.vue";
import RefsClearanceApproval from "../utility/RefsClearanceApproval.vue";

enum ClearanceSteps {
  CREATE_SHARING = "CREATE_SHARING",
  SEND_MAIL = "SEND_MAIL",
  SUCCESS = "SUCCESS"
}

@Component({
  components: {
    ConfirmActionDialog,
    RepairEstimatePartyForm,
    RefsSelect,
    PreselectTemplateCard,
    RefsClearanceApproval,
    ClearanceApprovalSideCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ClearanceShareDialog extends mixins(PermissionMixin) implements IDialog {
  readonly ClearanceSteps = ClearanceSteps;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard: any;

  @Prop()
  partnerId!: string;

  @Prop()
  hideButton!: boolean;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop({ default: false })
  hideRefsSelect!: boolean;

  @Prop()
  sellerCompanyId?: string;

  @Prop()
  value!: IClearance;

  isDialogActive = false;

  isLoading = false;

  step = ClearanceSteps.CREATE_SHARING;

  stepLocal = ClearanceSteps.CREATE_SHARING;

  sharedContent: ISharedContent = new SharedContent({
    partnerId: this.partnerId,
    refs: this.refs
  });

  refsSelectAsList = false;

  isSharingLoading = false;

  selectedClearanceApproval: IClearanceApproval | null = null;

  clearanceApprovals: IClearanceApproval[] = [];

  get context() {
    return {
      partner: this.partner,
      clearance: this.value,
      report: this.value.report,
      vehicle: this.value.report?.vehicle,
      sharedContent: this.sharedContent,
      url: { sharing: this.sharedContent?.url ?? "" }
    };
  }

  get currentStep() {
    return this.steps.get(this.stepLocal);
  }

  get user() {
    return UserModule.user;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get attachmentFileFilters() {
    return this.value.report?.refFilter || [];
  }

  get steps() {
    return new Map([
      [
        ClearanceSteps.CREATE_SHARING,
        {
          title: this.$t("clearance.createSharing"),
          backText: $t("close"),
          nextText: $t("common.verbs.share"),
          loading: false,
          back: () => {
            this.close();
          },
          next: async () => {
            try {
              this.isSharingLoading = true;
              this.sharedContent.refs.push({
                refId: this.value.id,
                refType: ResourceEnum.CLEARANCE
              });

              if (!this.sharedContent.id) {
                await this.sharedContent.create();
                this.$emit("create:sharedContent", this.sharedContent);
              } else {
                await this.sharedContent.update();
              }

              this.stepLocal = ClearanceSteps.SEND_MAIL;
            } catch (e) {
              handleError(e);
            } finally {
              this.isSharingLoading = false;
            }
          }
        }
      ],
      [
        ClearanceSteps.SEND_MAIL,
        {
          title: this.$t("clearance.sendMail"),
          backText: $t("back"),
          nextText: $t("clearance.sendMail"),
          loading: false,
          back: () => {
            this.stepLocal = ClearanceSteps.CREATE_SHARING;
          },
          next: async () => {
            try {
              await this.templateCard.send();
              await this.value.updatePartial({
                status: RequestStatusEnum.ACCEPTED
              });
              this.stepLocal = ClearanceSteps.SUCCESS;
            } catch (e) {
              handleError(e);
            }
          }
        }
      ],
      [
        ClearanceSteps.SUCCESS,
        {
          title: this.$t("clearance.success"),
          backText: $t("close"),
          nextText: $t("common.verbs.view"),
          loading: false,
          back: () => this.close(),
          next: () => this.viewCreated()
        }
      ]
    ]);
  }

  async open(sharedContent?: ISharedContent) {
    this.stepLocal = ClearanceSteps.CREATE_SHARING;

    if (sharedContent) {
      this.sharedContent = sharedContent;
    }

    this.loadClearanceApprovals();

    this.isDialogActive = true;

    this.onReportIdChange();
  }

  @Watch("value.reportId")
  async onReportIdChange() {
    await this.value.fetchReportAndVehicle().catch(this.$log.error);
  }

  async loadClearanceApprovals() {
    this.isLoading = true;
    const clearanceApprovalAsync = [];
    for (const clearanceApprovalId of this.value.clearanceApprovalIds) {
      if (clearanceApprovalId) {
        clearanceApprovalAsync.push(
          ClearanceApprovalDataAccessLayer.get(clearanceApprovalId) ??
            new ClearanceApproval({
              partnerId: this.partnerId,
              id: clearanceApprovalId
            })
              .fetch()
              .catch(e => {
                this.$log.error(e);
                return null;
              })
        );
      }
    }
    const clearanceApprovals = await Promise.all(clearanceApprovalAsync);
    const clearanceApprovalsFiltered = clearanceApprovals.filter(c => !!c) as IClearanceApproval[];
    this.clearanceApprovals.splice(0);
    this.clearanceApprovals.push(...clearanceApprovalsFiltered);
    this.isLoading = false;
  }

  close() {
    this.stepLocal = ClearanceSteps.CREATE_SHARING;
    this.isLoading = false;
    this.value = new Clearance({
      partnerId: this.partnerId,
      seller: new InvoiceParty(),
      refs: this.refs
    });
    this.isDialogActive = false;
  }

  setSelectedClearanceApproval(value: IClearanceApproval) {
    this.selectedClearanceApproval = null;

    this.$nextTick(() => {
      this.close();
      this.selectedClearanceApproval = value;
    });
  }

  reset() {
    this.value = new Clearance({
      partnerId: this.partnerId,
      seller: new InvoiceParty(),
      refs: this.refs
    });
    this.stepLocal = ClearanceSteps.CREATE_SHARING;
  }

  viewCreated() {
    this.value.goTo(this.$router).detail();
  }

  copyUrl() {
    this.sharedContent.copyLinkToClipboard();
  }
}
